import React from 'react';
import { useRecoilValue } from 'recoil';
import { Icon, Label } from '@nooz-optics/nooz-components-lib';
import { Form } from '../../../../UI/Forms/Form/form';
import { collectionFiltersState } from '../../../../../utils/recoil/collection';
import { withLocation } from '../../../../../utils/hocs';
import FilterService from '../../../../../services/FilterService';

export const ShopsWithNavFilters = withLocation(({ filters, search }) => {
  const collectionFilters = useRecoilValue(collectionFiltersState);
  const onFilterFormSubmit = (data) => {
    const filtersInputs = { ...collectionFilters, ...data };

    // Delete keys with empty arrays
    Object.keys(filtersInputs).forEach((key) => {
      if (filtersInputs[key]?.length === 0 || !filtersInputs[key]) {
        delete filtersInputs[key];
      }
    });
    FilterService.toURL(data);
  };

  return (
    <>
      {filters?.items?.map((form, index) => {
        const filterChevronIcon = (
          <Icon
            iconKey='HiChevronDown'
            size='2xl'
            color={{ classname: 'primary' }}
          />
        );
        return (
          <>
            <div className='w-full my-2 border-t border-gray-400' />
            <div>
              <div className='mb-2'>
                <Label
                  {...form.label}
                  size='sm'
                  weight='bold'
                  transform='uppercase'
                />
              </div>
              <Form
                {...form}
                defaultValues={collectionFilters}
                onChange={onFilterFormSubmit}
              />
            </div>
          </>
        );
      })}
    </>
  );
});
